module.exports = __webpack_public_path__ + "img/plate_driving.f15cb56e.svg";